import React from 'react'
import styles from './box.module.css'

export default ({ children }) => (
  <div className={styles.box} >{children}</div>
)
